import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, SealProvider } from "./contexts";
import MainView from "./components/main/MainView";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { IntlProvider } from "react-intl";
import { CookiesProvider } from "react-cookie";

const queryClient = new QueryClient();

function App() {
  return (
    <CookiesProvider>
      <IntlProvider locale="en">
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <SealProvider>
                <MainView />
              </SealProvider>
            </AuthProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </IntlProvider>
    </CookiesProvider>
  );
}

export default App;
